import { render, staticRenderFns } from "./commRender.vue?vue&type=template&id=fa7e1a8c&scoped=true"
import script from "./commRender.vue?vue&type=script&lang=js"
export * from "./commRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7e1a8c",
  null
  
)

export default component.exports